import React, { ReactNode } from 'react';

export interface ThreeColumnLayoutProps {
  leftSidebar: ReactNode;
  rightSidebar?: ReactNode;
  mainContent: ReactNode;
  mobileHeader?: ReactNode;
  showMobileMenu?: boolean;
  showMobileProfile?: boolean;
}

export const ThreeColumnLayout: React.FC<ThreeColumnLayoutProps> = ({
  leftSidebar,
  rightSidebar,
  mainContent,
  mobileHeader,
}) => {
  return (
    <div className="min-h-screen bg-base-100">
      {/* Mobile Header */}
      {mobileHeader && (
        <header className="lg:hidden fixed top-0 left-0 right-0 z-50 bg-base-100 border-b border-base-200">
          {mobileHeader}
        </header>
      )}

      {/* Main Layout */}
      <div className="flex h-screen">
        {/* Left Sidebar - Hidden on mobile, visible on desktop */}
        <aside className="hidden lg:flex w-64 bg-base-200 border-r border-base-300 flex-shrink-0">
          <div className="flex flex-col w-full h-full overflow-hidden">{leftSidebar}</div>
        </aside>

        {/* Main Content */}
        <main className="flex-1 flex flex-col bg-base-100 min-w-0">
          <div className="flex-1 overflow-auto pt-16 lg:pt-0">{mainContent}</div>
        </main>

        {/* Right Sidebar - Hidden on smaller screens, visible on xl */}
        {rightSidebar && (
          <aside className="hidden xl:flex w-96 bg-base-200 border-l border-base-300 flex-shrink-0">
            <div className="flex flex-col w-full h-full overflow-hidden">{rightSidebar}</div>
          </aside>
        )}
      </div>
    </div>
  );
};
